import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class AbstractToggleList extends PureComponent {
  static propTypes = {
    containerComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
      .isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
      })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    renderItem: PropTypes.func.isRequired
  };

  onChange = (...args) => this.props.onChange(...args);

  isValueSelected() {
    throw new Error('not implemented');
  }

  render() {
    const { containerComponent: Container, items, renderItem } = this.props;

    return (
      <Container>
        {items.map((item) =>
          renderItem({
            item,
            key: item.value,
            checked: this.isValueSelected(item.value),
            onChange: this.onChange
          })
        )}
      </Container>
    );
  }
}
